export const INIT_PLATFORMS = [
  {
    id: 'all',
    data: 'All Offers',
  },
  {
    id: 'online',
    data: 'Online brands',
  },
  {
    id: 'offline',
    data: 'Offline stores',
  },
];

export const INIT_FILTERS = {
  category: [
    {
      id: 1,
      name: 'Travel',
      redeem_type: '',
      logo: 'https://cdn.twidpay.com/co/category_images/travel_3.png',
    },
    {
      id: 4,
      name: 'Fashion',
      redeem_type: '',
      logo: 'https://cdn.twidpay.com/co/category_images/Group_2357.png',
    },
  ],
  brand: {
    preferred_brands: [
      {
        merchant_id: 65119,
        merchant_name: 'AbhiBus',
        merchant_logo:
          'https://cdn.twidpay.com/co/brand_logos/square/abhibussquare.svg',
        redirect_url: null,
        primary_category_id: 1,
        merchant_type: 'online',
        merchant_rank: null,
      },
      {
        merchant_id: 70150,
        merchant_name: 'EatFit',
        merchant_logo:
          'https://cdn.twidpay.com/co/mobile_app_images/eatfitssquare.svg',
        redirect_url: null,
        primary_category_id: 17,
        merchant_type: 'online',
        merchant_rank: null,
      },
    ],
    all_other_brands: [
      {
        merchant_id: 17,
        merchant_name: 'Cobb',
        merchant_logo:
          'https://cdn.twidpay.com/co/mobile_app_images/cobbsquare.svg',
        redirect_url: null,
        primary_category_id: 4,
        merchant_type: 'online',
        merchant_rank: null,
      },
      {
        merchant_id: 67706,
        merchant_name: 'Ixigo',
        merchant_logo:
          'https://cdn.twidpay.com/co/brand_logos/square/ixigosquare.svg',
        redirect_url: null,
        primary_category_id: 1,
        merchant_type: 'online',
        merchant_rank: null,
      },
    ],
  },
  offer_type: [
    {
      id: 'instant',
      data: 'Instant Discount',
      image:
        'https://static.twidpay.com/co/mobile_app_images/icons/discount.png',
    },
    {
      id: 'cashback',
      data: 'Coupon Cashback',
      image:
        'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    },
    {
      id: 'reward_cashback',
      data: 'Reward Cashback',
      image:
        'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    },
  ],
  offer_value: [
    {
      id: 'all',
      data: 'All Offers',
    },
    {
      id: 'ov_1',
      data: '₹25 or more',
    },
    {
      id: 'ov_2',
      data: '₹50 or more',
    },
    {
      id: 'ov_3',
      data: '₹100 or more',
    },
  ],
  reward_offer: [],
  platform: [
    {
      id: 'all',
      data: 'All Offers',
    },
    {
      id: 'online',
      data: 'Online brands',
    },
    {
      id: 'offline',
      data: 'Offline stores',
    },
  ],
};

export const INIT_OFFER_TYPES = [
  {
    id: 'cashback',
    data: 'Coupon Cashback',
    image: 'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
  },
  {
    id: 'instant',
    data: 'Instant Discount',
    image: 'https://static.twidpay.com/co/mobile_app_images/icons/discount.png',
  },
  {
    id: 'reward_cashback',
    data: 'Reward Cashback',
    image: 'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
  },
  {
    id: 'bank_cashback',
    data: 'Bank Offers',
    image: 'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
  },
  {
    id: 'exclusive_cashback',
    data: 'Brand Coupon',
    image: 'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
  },
];

export const INIT_CATEGORIES = [
  {
    id: 41,
    name: 'Travel',
    logo: 'https://cdn.twidpay.com/co/category_images/travel.png',
  },
  {
    id: 39,
    name: 'Utility Payments',
    logo: 'https://cdn.twidpay.com/co/category_images/utilities_and_bills.png',
  },
  {
    id: 8,
    name: 'Electronics',
    logo: 'https://cdn.twidpay.com/co/category_images/electronics.png',
  },
  {
    id: 36,
    name: 'Food',
    logo: 'https://cdn.twidpay.com/co/category_images/food.png',
  },
  {
    id: 2,
    name: 'Grocery',
    logo: 'https://cdn.twidpay.com/co/category_images/grocery.png',
  },
  {
    id: 26,
    name: 'Fashion',
    logo: 'https://cdn.twidpay.com/co/category_images/fashion.png',
  },
];

// @TODO TO BE CLEARED
export const INIT_BRANDS = {
  preferred_brands: [
    {
      merchant_id: 74863,
      merchant_name: 'EatSure',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/eatsuresquare.png',
      redirect_url: 'https://www.eatsure.com/',
      primary_category_id: 22,
    },
    {
      merchant_id: 75550,
      merchant_name: 'Jio Fiber Payment',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
      redirect_url: 'https://www.jio.com/',
      primary_category_id: 39,
    },
    {
      merchant_id: 75517,
      merchant_name: 'Milkbasket',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/milkbasketsquare.png',
      redirect_url: 'https://www.milkbasket.com/',
      primary_category_id: 2,
    },
  ],
  all_other_brands: [
    {
      merchant_id: 75549,
      merchant_name: 'Jio prepaid',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
      redirect_url: 'https://www.jio.com/',
      primary_category_id: 39,
    },
    {
      merchant_id: 75492,
      merchant_name: 'Jiomart',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/jiomartsquare.png',
      redirect_url: 'https://www.jiomart.com',
      primary_category_id: 2,
    },
    {
      merchant_id: 75595,
      merchant_name: 'samsung',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/samsungsquare.png',
      redirect_url: 'https://www.samsung.com/in/',
      primary_category_id: 10,
    },
    {
      merchant_id: 76003,
      merchant_name: 'Netmeds Rewards',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
      redirect_url: 'https://www.netmeds.com/',
      primary_category_id: 18,
    },
    {
      merchant_id: 67483,
      merchant_name: 'TimesPrime',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/timesprimesquare.png',
      redirect_url: 'https://www.timesprime.com/',
      primary_category_id: 18,
    },
    {
      merchant_id: 323,
      merchant_name: 'BookMyShow',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/bookmyshowsquare.png',
      redirect_url: 'https://www.bookmyshow.com',
      primary_category_id: 38,
    },
    {
      merchant_id: 75632,
      merchant_name: 'ConfirmTkt',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/confirmtktsquare.png',
      redirect_url: 'https://www.confirmtkt.com/',
      primary_category_id: 41,
    },
    {
      merchant_id: 67521,
      merchant_name: 'EaseMytrip',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/easemytripsquare.png',
      redirect_url: 'https://www.easemytrip.com/',
      primary_category_id: 41,
    },
    {
      merchant_id: 76050,
      merchant_name: 'Ixigo Flight',
      merchant_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/ixigoflightsquare.png',
      redirect_url: 'https://www.ixigo.com/flights',
      primary_category_id: 18,
    },
  ],
};

export const INIT_OFFERS = [
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'INSTANT',
    offer_tag: 'instant',
    offer_title: 'Get ₹5 OFF Instant Discount',
    offer_subtitle: null,
    offer_value: 5,
    brand_id: 1,
    brand_logo:
      'https://static.twidpay.com/co/mobile_app_images/icons/multi_brand.png',
    brand_name: 'All Brands',
    code: 'JIOPREOCT2',
    category_id: 11,
    type: 'online',
    voucher_id: 618054,
    voucher_campaign_details_id: 3917,
    expiry_date: '2024-10-30 19:43:05',
    expiry_logo:
      'https://static.twidpay.com/co/mobile_app_images/icons/expiry.png',
    expiry_text: 'Expiring in 1 Days',
    expiry_text_color: '#FF6357',
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/discount.png',
    tag_text: 'Discount',
    tag_color: '0BAE1F',
    offer_filter_type: 'guaranteed',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'INSTANT',
    offer_tag: 'instant',
    offer_title: 'Get ₹11 OFF Instant Discount',
    offer_subtitle: null,
    offer_value: 11,
    brand_id: 75549,
    brand_logo:
      'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
    brand_name: 'Jio prepaid',
    code: '1TWIDAPP11',
    category_id: 39,
    type: 'online',
    voucher_id: 627614,
    voucher_campaign_details_id: 4095,
    expiry_date: '2024-10-31 23:59:59',
    expiry_logo:
      'https://static.twidpay.com/co/mobile_app_images/icons/expiry.png',
    expiry_text: 'Expiring in 2 Days',
    expiry_text_color: '#FF6357',
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/discount.png',
    tag_text: 'Discount',
    tag_color: '0BAE1F',
    offer_filter_type: 'guaranteed',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'INSTANT',
    offer_tag: 'instant',
    offer_title: 'Get ₹11 OFF Instant Discount',
    offer_subtitle: null,
    offer_value: 11,
    brand_id: 75549,
    brand_logo:
      'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
    brand_name: 'Jio prepaid',
    code: 'TWIDAPP11',
    category_id: 39,
    type: 'online',
    voucher_id: 625745,
    voucher_campaign_details_id: 4077,
    expiry_date: '2024-10-31 23:59:59',
    expiry_logo:
      'https://static.twidpay.com/co/mobile_app_images/icons/expiry.png',
    expiry_text: 'Expiring in 3 Days',
    expiry_text_color: '#FF6357',
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/discount.png',
    tag_text: 'Discount',
    tag_color: '0BAE1F',
    offer_filter_type: 'guaranteed',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'cashback',
    offer_title: 'Flat Rs.125 off on Eatsure',
    offer_subtitle:
      'Flat Rs.125 off on Eatsure on your first order above Rs.249',
    offer_value: 100,
    brand_id: 74863,
    brand_logo: 'https://static.twidpay.com/co/brand_logos/square/eatsure.svg',
    brand_name: 'EatSure',
    code: 'ES125',
    category_id: 11,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 3896,
    expiry_date: '2024-10-31 23:59:59',
    expiry_logo:
      'https://static.twidpay.com/co/mobile_app_images/icons/expiry.png',
    expiry_text: 'Expiring in 2 Days',
    expiry_text_color: '#FF6357',
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'recommended',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'cashback',
    offer_title: '8% Cashback UP TO 60 ON MOV 399',
    offer_subtitle: '8% Cashback UP TO 60 ON MOV 399',
    offer_value: 60,
    brand_id: 75548,
    brand_logo:
      'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
    brand_name: 'Jio Fiber Registration',
    code: 'FIBER50',
    category_id: 39,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 1970,
    expiry_date: null,
    expiry_logo: null,
    expiry_text: null,
    expiry_text_color: null,
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'recommended',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'cashback',
    offer_title: '10% Cashback UP TO 60 ON MOV 399',
    offer_subtitle: '10% Cashback UP TO 60 ON MOV 399',
    offer_value: 60,
    brand_id: 75550,
    brand_logo:
      'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
    brand_name: 'Jio Fiber Payment',
    code: 'FIBER50',
    category_id: 39,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 1971,
    expiry_date: null,
    expiry_logo: null,
    expiry_text: null,
    expiry_text_color: null,
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'recommended',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'cashback',
    offer_title: '5% Cashback upto Rs.3000, No MOV',
    offer_subtitle: '5% Cashback upto Rs.3000, No MOV',
    offer_value: 50,
    brand_id: 75595,
    brand_logo:
      'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/samsungsquare.png',
    brand_name: 'samsung',
    code: 'SAMSUNG3000',
    category_id: 8,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 1972,
    expiry_date: null,
    expiry_logo: null,
    expiry_text: null,
    expiry_text_color: null,
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'recommended',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'reward_cashback',
    offer_title: 'Get 25x Supercoin Earning',
    offer_subtitle: null,
    offer_value: 0,
    brand_id: 304,
    brand_logo:
      'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/flipkart.png',
    brand_name: 'Flipkart',
    code: null,
    category_id: 18,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: null,
    expiry_date: null,
    expiry_logo: null,
    expiry_text: null,
    expiry_text_color: null,
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'issuer',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'reward_cashback',
    offer_title: 'Get Flat 50 cashback on order of Rs 999 or above',
    offer_subtitle: 'Get Flat 50 cashback on order of Rs 999 or above',
    offer_value: 0,
    brand_id: 76003,
    brand_logo:
      'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
    brand_name: 'Netmeds Rewards',
    code: 'NETMEDS50',
    category_id: 18,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 2944,
    expiry_date: null,
    expiry_logo: null,
    expiry_text: null,
    expiry_text_color: null,
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'issuer',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'bank_cashback',
    offer_title: '10% cashback upto Rs 100',
    offer_subtitle: '10% cashback upto Rs 100',
    brand_id: 500,
    offer_value: 100,
    brand_logo: 'https://static.twidpay.com/co/brand_images/visa.svg',
    brand_name: 'twid Merchant Account',
    code: 'VISA10',
    category_id: 1,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 2334,
    expiry_date: null,
    expiry_logo: null,
    expiry_text: null,
    expiry_text_color: '#FF6357',
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'bank',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'exclusive_cashback',
    offer_title: 'Flat Rs.360 off on Times Prime premium pack',
    offer_subtitle: 'Flat Rs.360 off on Times Prime premium pack',
    brand_id: 67483,
    offer_value: 1,
    brand_logo: 'https://static.twidpay.com/me/timesprimesquare.jpg',
    brand_name: 'TimesPrime',
    code: 'TP360',
    category_id: 11,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 3137,
    expiry_date: '2024-12-31 23:59:59',
    expiry_logo:
      'https://static.twidpay.com/co/mobile_app_images/icons/expiry2.png',
    expiry_text: 'Valid till 31 DEC 24',
    expiry_text_color: '#F7F8FC',
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'exclusive',
  },
  {
    offer_image:
      'https://static.twidpay.com/mobile_app_images/airplane_dark_image.png',
    offer_type: 'CASHBACK',
    offer_tag: 'exclusive_cashback',
    offer_title: 'Get Upto Rs 3000/- off on EaseMyTrip.',
    offer_subtitle: 'Get Upto Rs 3000/- off on EaseMyTrip.',
    brand_id: 67521,
    offer_value: 1,
    brand_logo: 'https://static.twidpay.com/me/Easemytrip.jpg',
    brand_name: 'EaseMytrip',
    code: 'EMTTWID',
    category_id: 41,
    type: 'online',
    voucher_id: null,
    voucher_campaign_details_id: 3724,
    expiry_date: '2024-12-31 23:59:59',
    expiry_logo:
      'https://static.twidpay.com/co/mobile_app_images/icons/expiry2.png',
    expiry_text: 'Valid till 31 DEC 24',
    expiry_text_color: '#F7F8FC',
    tag_url:
      'https://static.twidpay.com/co/mobile_app_images/icons/cashback.png',
    tag_text: 'Cashback',
    tag_color: 'E5A500',
    offer_filter_type: 'exclusive',
  },
];
export const OFFER_DETAILS = {
  status: true,
  data: {
    offer: {
      voucher_code: 'ITCSTORENEW',
      voucher_image_url: 'https://cdn.twidpay.com/co/offer_banner/itc.png',
      voucher_expiry: '2024-09-30 00:00:00',
      voucher_title: 'Upto 50% OFF + EXTRA ₹250 OFF on 1st Order!',
      voucher_subtitle: 'on 1st Order!',
      voucher_type_url:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/discount_shape.svg',
      voucher_type_text: 'Discount',
      voucher_type_color: '0BAE1F',
      brand_logo:
        'https://static.twidpay.com/co/mobile_app_images/brand_logos/square/itcsquare.png',
      brand_name: 'ITC',
      expiry_logo:
        'https://static.twidpay.com/co/mobile_app_images/icons/expiry2.png',
      expiry_text: 'Valid Till',
      expiry_text_color: '#FF6357',
    },
    brand_redirect_url:
      'http://itcstore.in?utm_source=twid_brand_listing&utm_medium=offer_promtion&utm_campaign=brand_partnership',
    tnc: '<p>Offer valid from 15th July 2024 to 30th September 2024.</p>\n<br>\n<p>Discount applicable on a minimum purchase of Rs. 999 or more.</p>\n<br>\n<p>Apply code ITCSTORENEW at checkout to avail the offer.</p>\n<br>\n<p>Offer is valid for new customers or 1st order at the ITC Store.</p>\n<br>\n<p>Vouchers valid on all products available at ITC Store except Hotel products.</p>\n<br>\n<p>For customer queries related to shipment, please write to support@itcstore.in .</p>\n',
    how_to_redeem: [
      {
        data: 'Visit ITCstore.in or download the ITC Store App',
        image:
          'https://static.twidpay.com/co/mobile_app_images/brand_logos/square/itcsquare.png',
      },
      {
        data: 'Pick your favourite items',
        image:
          'https://static.twidpay.com/co/mobile_app_images/icons/twid_white.png',
      },
      {
        data: 'Apply code ITCSTORENEW at checkout to avail the discount',
        image:
          'https://static.twidpay.com/co/mobile_app_images/icons/reward_coupon.png',
      },
      {
        data: 'Complete the payment',
        image:
          'https://static.twidpay.com/co/mobile_app_images/icons/yestick.png',
      },
    ],
    similar_offers: [],
    other_offers: [],
  },
  error_code: null,
  message: null,
};
